import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LANDING_LINKS, stickyCtaLabel } from "./landingContent";

const SHOW_AFTER = 380;
const HIDE_NEAR_BOTTOM = 520;

export default function LandingStickyCta() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || 0;
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight - HIDE_NEAR_BOTTOM;
      setVisible(y > SHOW_AFTER && y < max);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="hr-landing-sticky" role="region" aria-label="פעולה מהירה">
      <Link to={LANDING_LINKS.registerAgent} className="hr-landing-sticky__btn">
        {t("navbar.joinasagent") || stickyCtaLabel}
      </Link>
    </div>
  );
}
